import tw, { styled } from 'twin.macro';

const Nav = styled.div`
  ${tw`absolute left-0`}
  top: 72px;
  padding: 10px;
`;

export default Nav;
